<template>
  <div v-wechat-title="titleTop" class="bodyBack">
    <topImg />
    <div class="boatImgRect" v-if="data.boat">
      <van-swipe :autoplay="3000" @change="onChange">
        <van-swipe-item v-for="(image, index) in data.boat.images" :key="index" @click="onViewFullImage">
          <van-image
            fit="cover"
            :width="'calc(100vw - 3em)'"
            height="60vw"
            :src="image"
          /></van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">{{ current + 1 }}/{{data.boat.images.length}}</div>
        </template>
      </van-swipe>
      <div class="imgTitle">{{data.boat.showTitle}}<span v-if="data.boat.countryCHS">,{{data.boat.countryCHS}}</span></div>
    </div>

    <div class="SerchRect">
      <van-field v-model="search.date" class="SearchLine" placeholder="出行日期" right-icon="arrow-down" readonly  @click="showDatePick=true"/>
    </div>
    <van-skeleton :row="20" :loading="loading">
      <div class="tourTitle" v-if="data.tour"><span>{{data.tour.tourDayDay}}天/{{data.tour.tourDayNight}}晚</span><span v-if="data.tour.diveCountText">（总共大约{{data.tour.diveCountText}}次深潜）</span></div>
      <div class="roomRects" v-if="data.roomList">
        <div class="roomRect" v-for="room in data.roomList" :key="room.boatRoomId" @click="showRoom(room)">
          <van-row>
            <van-col span="7"><van-image
              fit="cover"
              :width="'calc(20vw - 0.0em)'"
              :height="'calc(20vw - 0.0em)'"
              :src="room.imgIds"
              class="roomImg"
            /></van-col>
            <van-col span="17">
              <div class="roomTitle">{{room.roomName}}</div>
              <div class="tagLine"><van-tag round color="#EFF8FF" v-if="room.priceAbout" text-color="#2E79EA">{{room.priceAbout}}</van-tag></div>
              <div class="priceLine">
                <van-row>
                  <van-col span="12" class="price">USD <span>{{room.priceBase}}</span></van-col>
                  <van-col span="12" class="free" v-if="room.quota<0">余位:多</van-col>
                  <van-col span="12" class="free" v-if="room.quota>0">余位:{{room.quota}}</van-col>
                  <van-col span="12" class="freeEmpty" v-if="room.quota==0">余位:{{room.quota}}</van-col>
                </van-row>
              </div>
            </van-col>
          </van-row>
        </div>
        <van-button class="searchButton" color="linear-gradient(to right, #0EBEFA , #1A8CFE)" size="large" @click="jumpUrl('/boat/boatFollow')">行程咨询及预定
          <i class="iconfont iconlightning" />
        </van-button>
      </div>
      <div class="boatInfoRect">
        <template v-if="data&&data.tour&&data.boat">
          <div :class="showTourInfo?'infoTitleOpen':'infoTitleClose'" @click="showTourInfo=!showTourInfo">
            行程概要<i :class="showTourInfo?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showTourInfo" class="infoLineRect">
            <van-row class="line">
              <van-col span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col span="22"><b>船只名称：</b>{{data.boat.showTitle}}</van-col>
            </van-row>
            <van-row class="line">
              <van-col span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col span="22"><b>船宿行程：</b>{{data.tour.tourTitle}}</van-col>
            </van-row>
            <van-row class="line">
              <van-col span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col span="22"><b>出行国家：</b>{{data.boat.countryCHS}}</van-col>
            </van-row>
          
            <van-row class="line">
              <van-col span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col span="22"><b>出行日期：</b>{{formatDate(data.tour.tourDate,'yyyy年MM月dd日')}}</van-col>
            </van-row>
            <van-row class="line">
              <van-col span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col span="22"><b>行程长度：</b>{{data.tour.tourDayDay}}天/{{data.tour.tourDayNight}}晚</van-col>
            </van-row>
          </div>
        </template>
        <template v-if="data.boat&&data.boat.about">
          <div :class="showBoatAbout?'infoTitleOpen':'infoTitleClose'" @click="showBoatAbout=!showBoatAbout">
            船只介绍<i :class="showBoatAbout?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showBoatAbout" class="infoLineRect textRect">
            <div v-html="data.boat.about"/>
          </div>
        </template>

         <template v-if="data && data.commentList &&data.commentList.length>0">
          <div :class="showCommentInfo?'infoTitleOpen':'infoTitleClose'" @click="showCommentInfo=!showCommentInfo">
            用户评价<i :class="showCommentInfo?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showCommentInfo" class="infoLineRect">
            <div class="topStar">
              <van-rate v-model="avgStar" size="26px" readonly allow-half void-icon="star" void-color="#eee" />
              <div class="scoreLine" v-if="avgScore>=9">{{avgScore.toFixed(1)}} 精选船宿</div>
              <div class="scoreLine" v-else>{{avgScore.toFixed(1)}} 优选船宿</div>
            </div>

            <div class="avgScore">
              <van-row>
                <van-col span="12" class="lineName">船只硬件</van-col>
                <van-col span="12" class="lineScore">{{avgScore1.toFixed(1)}}</van-col>
              </van-row>
              <div class="barBack">
                <div class="barRect" :style="'width:'+(avgScore1*10)+'%'"></div>
              </div>

              <van-row>
                <van-col span="12" class="lineName">船员服务</van-col>
                <van-col span="12" class="lineScore">{{avgScore2.toFixed(1)}}</van-col>
              </van-row>
              <div class="barBack">
                <div class="barRect" :style="'width:'+(avgScore2*10)+'%'"/>
              </div>

              <van-row>
                <van-col span="12" class="lineName">行程餐食</van-col>
                <van-col span="12" class="lineScore">{{avgScore3.toFixed(1)}}</van-col>
              </van-row>
              <div class="barBack">
                <div class="barRect" :style="'width:'+(avgScore3*10)+'%'"/>
              </div>

              <van-row>
                <van-col span="12" class="lineName">潜水体验</van-col>
                <van-col span="12" class="lineScore">{{avgScore4.toFixed(1)}}</van-col>
              </van-row>
              <div class="barBack">
                <div class="barRect" :style="'width:'+(avgScore4*10)+'%'"/>
              </div>

              <van-row>
                <van-col span="12" class="lineName">行程性价比</van-col>
                <van-col span="12" class="lineScore">{{avgScore5.toFixed(1)}}</van-col>
              </van-row>
              <div class="barBack">
                <div class="barRect" :style="'width:'+(avgScore5*10)+'%'"/>
              </div>
            </div>

            <div class="commentRect" v-for="comment in data.commentList" :key="comment.diveOrderUserCommentId">
              <div class="commentTop">
                <div class="leftRect">
                  <van-rate v-model="comment.star" readonly void-icon="star" void-color="#eee" />
                  <div class="score" v-if="comment.scoreAgv>=90"><span>{{(comment.scoreAgv/10).toFixed(1)}}</span> 优秀</div>
                  <div class="score" v-else-if="comment.scoreAgv>=60"><span>{{(comment.scoreAgv/10).toFixed(1)}}</span> 普通</div>
                  <div class="score" v-else><span>{{(comment.scoreAgv/10).toFixed(1)}}</span> 不推荐</div>
                </div>
                <div class="icon">
                  <img :src="data.icon?data.icon:'/img/defaultIcon.jpg'"/>
                </div>
                <div class="rightRect1">
                  <span>{{comment.nickName}}</span>
                </div>
                <div class="rightRect2">
                  船期{{formatDate(comment.tripDate,'yyyy-MM-dd')}}
                </div>
              </div>
              <div class="commentbody">
                {{comment.about}}
              </div>
            </div>
          </div>
        </template>

        <template v-if="data && data.boat &&data.boat.boatSpecialTag">
          <div :class="showBoatInfo?'infoTitleOpen':'infoTitleClose'" @click="showBoatInfo=!showBoatInfo">
            船只亮点<i :class="showBoatInfo?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showBoatInfo" class="infoLineRect">
            <van-row class="line" v-for="(item, index) in data.boat.boatSpecialTagList" :key="index">
              <!-- 第一列 -->
              <van-col v-if="index%2===0" span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col v-if="index%2===0" span="10">{{ item }}</van-col>
              <!-- 第二列 -->
              <van-col v-if="index%2===0&& index<data.boat.boatSpecialTagList.length-1" span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col v-if="index%2===0&& index<data.boat.boatSpecialTagList.length-1" span="10">{{ data.boat.boatSpecialTagList[index + 1] }}</van-col>
            </van-row>
          </div>
        </template>
        
       
        <template v-if="data && data.boat &&data.boat.foodDrinkTag">
          <div :class="showFoodInfo?'infoTitleOpen':'infoTitleClose'" @click="showFoodInfo=!showFoodInfo">
            餐饮特点<i :class="showFoodInfo?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showFoodInfo" class="infoLineRect">
            <van-row class="line" v-for="(item, index) in data.boat.foodDrinkTagList" :key="index">
              <!-- 第一列 -->
              <van-col v-if="index%2===0" span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col v-if="index%2===0" span="10">{{ item }}</van-col>
              <!-- 第二列 -->
              <van-col v-if="index%2===0&& index<data.boat.foodDrinkTagList.length-1" span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col v-if="index%2===0&& index<data.boat.foodDrinkTagList.length-1" span="10">{{ data.boat.foodDrinkTagList[index + 1] }}</van-col>
            </van-row>
          </div>
        </template>

        <template v-if="data && data.boat &&data.boat.deepDiveTag">
          <div :class="showDiveInfo?'infoTitleOpen':'infoTitleClose'" @click="showDiveInfo=!showDiveInfo">
            潜水服务<i :class="showDiveInfo?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showDiveInfo" class="infoLineRect">
            <van-row class="line" v-for="(item, index) in data.boat.deepDiveTagList" :key="index">
              <!-- 第一列 -->
              <van-col v-if="index%2===0" span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col v-if="index%2===0" span="10">{{ item }}</van-col>
              <!-- 第二列 -->
              <van-col v-if="index%2===0&& index<data.boat.deepDiveTagList.length-1" span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col v-if="index%2===0&& index<data.boat.deepDiveTagList.length-1" span="10">{{ data.boat.deepDiveTagList[index + 1] }}</van-col>
            </van-row>
          </div>
        </template>

        <template v-if="data && data.boat &&data.boat.navigationSafetyTag">
          <div :class="showSafeInfo?'infoTitleOpen':'infoTitleClose'" @click="showSafeInfo=!showSafeInfo">
            安全服务<i :class="showSafeInfo?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showSafeInfo" class="infoLineRect">
            <van-row class="line" v-for="(item, index) in data.boat.navigationSafetyTagList" :key="index">
              <!-- 第一列 -->
              <van-col v-if="index%2===0" span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col v-if="index%2===0" span="10">{{ item }}</van-col>
              <!-- 第二列 -->
              <van-col v-if="index%2===0&& index<data.boat.navigationSafetyTagList.length-1" span="2"><i class="iconfont iconsuccess rightIcon" /></van-col>
              <van-col v-if="index%2===0&& index<data.boat.navigationSafetyTagList.length-1" span="10">{{ data.boat.navigationSafetyTagList[index + 1] }}</van-col>
            </van-row>
          </div>
        </template>

        <template v-if="data.boat&&data.boat.equipmentJson">
          <div :class="showEquipInfo?'infoTitleOpen':'infoTitleClose'" @click="showEquipInfo=!showEquipInfo">
            装备租赁<i :class="showEquipInfo?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showEquipInfo" class="infoLineRect textRect">
            <div v-html="data.boat.equipmentJson"/>
          </div>
        </template>
        <template v-if="data.boat&&data.boat.includeUnit">
          <div :class="showIncludeInfo?'infoTitleOpen':'infoTitleClose'" @click="showIncludeInfo=!showIncludeInfo">
            费用信息<i :class="showIncludeInfo?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showIncludeInfo" class="infoLineRect textRect">
            <div v-html="data.boat.includeUnit"/>
          </div>
        </template>

        <template v-if="data.tour">
          <div :class="showTourMore?'infoTitleOpen':'infoTitleClose'" @click="showTourMore=!showTourMore">
            行程详情<i :class="showTourMore?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showTourMore" class="infoLineRect textRect">
            <div class="tourAllTitle">{{data.tour.tourTitle}}</div>
            <div class="tourRect">
              <div class="title">行程长度</div>
             {{data.tour.tourDayDay}}天/{{data.tour.tourDayNight}}晚
            </div>
            <div class="tourRect">
              <div class="title">出发</div>
              {{formatDate(data.tour.tourDate,'yyyy年MM月dd日')}}<br>
              {{data.tour.departureTime}}<br>
              <i class="iconfont iconwharf"/>{{data.tour.departurePort}}
            </div>
            <div class="tourRect">
              <div class="title">返回</div>
              {{data.tour.returnDateObj?formatDate(data.tour.returnDateObj,'yyyy年MM月dd日'):data.tour.returnDate}}<br>
              {{data.tour.returnTime}}<br>
              <i class="iconfont iconwharf"/>{{data.tour.returnPort}}
            </div>
            <div class="tourRect" v-if="data.tour.diveCountText">
              <div class="title">深潜</div>
               总共大约{{data.tour.diveCountText}}次深潜
            </div>
            <div class="tourRect" v-if="data.tour.difficulty">
              <div class="title">经验水平</div>
              {{data.tour.difficulty}}
            </div>
          </div>
        </template>
        <template v-if="data.tour&&data.tour.dailySummary">
          <div :class="showDailySummary?'infoTitleOpen':'infoTitleClose'" @click="showDailySummary=!showDailySummary">
            每日安排<i :class="showDailySummary?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showDailySummary" class="infoLineRect textRect">
            <div v-html="data.tour.dailySummary"/>
          </div>
        </template>
        <template v-if="data.tour&&data.tour.oceanLife">
          <div :class="showOceanLife?'infoTitleOpen':'infoTitleClose'" @click="showOceanLife=!showOceanLife">
            海洋生物<i :class="showOceanLife?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showOceanLife" class="infoLineRect textRect">
            <div v-html="data.tour.oceanLife"/>
          </div>
        </template>
        <template v-if="data.tour&&data.tour.otherComments">
          <div :class="showOtherComments?'infoTitleOpen':'infoTitleClose'" @click="showOtherComments=!showOtherComments">
            其他说明<i :class="showOtherComments?'iconfont iconupjt':'iconfont icondownjt'" />
          </div>
          <div v-if="showOtherComments" class="infoLineRect textRect">
            <div v-html="data.tour.otherComments"/>
          </div>
        </template>

        <div :class="showDisclaimer?'infoTitleOpen':'infoTitleClose'" @click="showDisclaimer=!showDisclaimer">
          免责声明<i :class="showDisclaimer?'iconfont iconupjt':'iconfont icondownjt'" />
        </div>
        <div v-if="showDisclaimer" class="infoLineRect">
          <p>　　我司作为全球船宿产品的代理机构，致力于提供潜水相关行程的代订服务。在此，我们特别提醒客户仔细阅读以下免责声明，以确保您充分了解相关事宜：</p>

          <p>🌟服务提供商：</p>
          <p>　　我司作为行程代理商，致力于为客户提供最佳的旅行服务。行程所涉及的服务，可能由第三方船公司提供，行程解释权归船公司所有。</p>

          <p>🌟行程变更风险：</p>
          <p>　　行程线路可能因天气、政府行为、罢工、天灾等不可抗因素导致变更或取消。我们将尽力通知您，并提供相关替代方案。</p>

          <p>🌟潜水安全风险：</p>
          <p>　　参与潜水活动存在一定风险，请遵守当地潜水规定和安全准则。我们不对因个人健康问题导致的损失负责。您应该遵循目的地的健康和安全建议，并在需要时寻求医疗帮助。</p>

          <p>🌟责任与义务：</p>
          <p>　　潜水行程可能发生因不限于上述风险所导致的损失，我司将尽力确保第三方船公司服务质量，但不对最终结果负责。我们建议您出行前应购买覆盖前述风险的个人潜水保险，以对抗可能发生的风险。</p>

          <p>🌟预订即表示同意：</p>
          <p>　　购买潜水行程船宿产品即表示您同意并接受上述免责声明的全部内容。</p>

          <p>🌟有疑问请联系：</p>
          <p>　　如有任何疑问或需要进一步了解，请随时联系我们，我们将尽力提供协助和解答。</p>
          <p>　　谢谢您对我们服务的信任与理解。</p>

        </div>
      </div>
      
    </van-skeleton>
    <!-- <div class="icpLine">蜀ICP备20019214号-1 成都酷潜文化旅游有限公司</div> -->
    <van-popup v-model="showRoomInfo" class="roomPopInfoRect">
      <van-row class="topTitle">
        <van-col span="16">客舱信息</van-col>
        <van-col span="8" class="closeIcon"><i class="iconfont iconclosex" @click="showRoomInfo=false" /></van-col>
      </van-row>
      <div class="roomImgRect" v-if="roomInfo">
        <van-swipe :autoplay="3000" @change="onChangeRoom" v-if="roomInfo.imgUrls && roomInfo.imgUrls.length>0">
          <van-swipe-item v-for="(image, index) in roomInfo.imgUrls" :key="index">
            <van-image
              fit="cover"
              :width="'calc(100vw - 6em)'"
              height="50vw"
              :src="image"
            /></van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">{{ currentRoom + 1 }}/{{roomInfo.imgUrls.length}}</div>
          </template>
        </van-swipe>
      </div>
      <div class="roomTitle" v-if="roomInfo">{{roomInfo.roomName}}</div>
      <div class="tagList" v-if="roomInfo">
        <van-row  gutter="20" v-if="roomInfo.tagsList.length!==4">
          <van-col span="12" class="tagLine" v-for="(tag,index) in roomInfo.tagsList" :key="index"><i class="iconfont iconvip" />{{tag}}</van-col>
        </van-row>
        <van-row  gutter="20" v-if="roomInfo.tagsList.length===4">
          <van-col span="12" class="tagLine"><i class="iconfont iconBed" />{{roomInfo.tagsList[0]}}</van-col>
          <van-col span="12" class="tagLine"><i class="iconfont iconfeng" />{{roomInfo.tagsList[1]}}</van-col>
          <van-col span="12" class="tagLine"><i class="iconfont iconlinyu" />{{roomInfo.tagsList[2]}}</van-col>
          <van-col span="12" class="tagLine"><i class="iconfont iconpeoples" />{{roomInfo.tagsList[3]}}</van-col>
        </van-row>
      </div>
      <div class="roomAbout" v-if="roomInfo">{{roomInfo.roomAbout}}</div>
    </van-popup>
    <van-popup v-model="showDatePick" position="bottom" class="popDialog">
      <van-picker
        title="选择出行日期"
        show-toolbar
        :columns="dateOption"
        @confirm="onConfirmDate"
        @cancel="onCancelDate"
      />
    </van-popup>
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
    <boatKf/>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Swipe, SwipeItem, Button, Field, Picker, Popup, Image, Checkbox, Tag,Skeleton,ImagePreview ,Rate  } from 'vant'
import topImg from '@/views/boat/boatTopImgBack.vue'
import { getUrlKey,ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { GetSelfUrl } from '@/utils/request'
import wxShare from '@/components/wxShare'
import  boatKf from '@/views/boat/boatKf.vue'
export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Image.name]: Image,
    [Button.name]: Button,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Tag.name]: Tag,
    [Skeleton.name]: Skeleton,
    [ImagePreview.name]: ImagePreview,
    [Rate.name]: Rate,
    topImg,
    wxShare,
    boatKf
  },
  data() {
    return {
      titleTop: '酷潜船宿精选',
      images: ['/img/boat/homtTopBack1.webp', '/img/boat/homtTopBack2.webp', '/img/boat/homtTopBack3.webp'],
      current: 0,
      currentRoom: 0,
      loading:true,
      search: {
        boatId: '',
        boatTourId:'',
        date:'',
      },
      data:{
        boat:undefined,
        tour:undefined,
        roomList:[],
        dateList:[]
      },
      showTourInfo:true,
      showBoatInfo: false,
      showCommentInfo:false,
      showBoatAbout: false,
      showFoodInfo:false,
      showDiveInfo:false,
      showSafeInfo:false,
      showEquipInfo:false,
      showIncludeInfo:false,
      showDisclaimer: false,
      showTourMore:false,
      showDailySummary:false,
      showOceanLife:false,
      showOtherComments:false,

      showRoomInfo: false,
      roomInfo:undefined,
      showDatePick:false,
      dateOption:[],
      
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: '',
      avgStar:0,
      avgScore:0,
      avgScore1:0,
      avgScore2:0,
      avgScore3:0,
      avgScore4:0,
      avgScore5:0,

    }
  },

  created() {
    this.titleTop = '酷潜船宿精选'
    this.search.boatId = this.$route.params.code
    this.search.boatTourId = getUrlKey('tourId')
    this.initData();
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onViewFullImage(){
      console.log("onViewFullImage",this.current)
      ImagePreview({
        images: this.data.boat.images,
        startPosition: this.current,
      });
    },
    onConfirmDate(value){
      this.search.date =value.text
      this.search.boatTourId = value.value
      this.showDatePick= false;
      this.initData()
      
    },
    onCancelDate(){
      this.search.date = ''
      this.search.boatTourId = ''
      this.showDatePick =false;
      this.initData()
    },
    onChange(index) {
      this.current = index
    },
    onChangeRoom(index) {
      this.currentRoom = index
    },
    jumpUrl(url){
      console.log("jumpUrl",url)
      if(url){
        this.$router.push(url)
      }
    },
    onShareFinish() {
      this.shareUrl = undefined
    },
    initData(){
      this.loading= true;
      request({
        url: '/DiveBoat/getBoatTourInfo',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data

        this.shareTitle = '酷潜船宿精选'
        let about =(this.data.boat.countryCHS?this.data.boat.countryCHS:this.data.boat.country)+this.data.boat.showTitle+this.data.tour.tourTitle
        this.shareAbout = about
        this.shareTimeline = about
        this.shareUrl = undefined
        this.shareUrl = GetSelfUrl() + 'boat/boatTourInfo/'+this.data.boat.boatId+'?tourId='+this.data.tour.boatTourId+'&system=cooldive'
        if(this.data.boat.images &&this.data.boat.images.length>0)
        {
          this.shareIcon =this.data.boat.images[0]
        }
        if(this.data.commentList && this.data.commentList.length>0)
        {
          this.data.commentList.forEach(el=>{
            el.star = el.scoreAgv/20;
            this.avgScore+= el.scoreAgv;
            this.avgScore1+= el.score1;
            this.avgScore2+= el.score2;
            this.avgScore3+= el.score3;
            this.avgScore4+= el.score4;
            this.avgScore5+= el.score5;
          })
          this.avgScore = this.avgScore/ this.data.commentList.length/10;
          this.avgStar = this.avgScore/2;
          this.avgScore1 = this.avgScore1/ this.data.commentList.length * 2;
          this.avgScore2 = this.avgScore2/ this.data.commentList.length * 2;
          this.avgScore3 = this.avgScore3/ this.data.commentList.length * 2;
          this.avgScore4 = this.avgScore4/ this.data.commentList.length * 2;
          this.avgScore5 = this.avgScore5/ this.data.commentList.length * 2;
        }

        if(this.data.boat)
        {
          if(this.data.boat.boatSpecialTag){
            this.data.boat.boatSpecialTagList = this.data.boat.boatSpecialTag.split(',')
          }
          if(this.data.boat.deepDiveTag){
            this.data.boat.deepDiveTagList = this.data.boat.deepDiveTag.split(',')
          }
          if(this.data.boat.foodDrinkTag){
            this.data.boat.foodDrinkTagList = this.data.boat.foodDrinkTag.split(',')
          }
          if(this.data.boat.navigationSafetyTag){
            this.data.boat.navigationSafetyTagList = this.data.boat.navigationSafetyTag.split(',')
          }
        }
        //出行日期处理
        let list = []
        let selectText = ''
        let selectValue = ''
        response.data.dateList.forEach(el=>{
          list.push({
            text:el.v,
            value:el.k
          })
          if(el.k === this.data.tour.boatTourId)
          {
            selectText= el.v;
            selectValue= el.k;
            console.log("找到",el.v)
          }
        })
        this.dateOption= list;
        setTimeout(() => {
          this.search.date = selectText
          this.search.boatTourId = selectValue
        }, 1);

        this.loading=false;
      })
    },
    showRoom(room){
      this.currentRoom= 0
      this.roomInfo= room
      this.showRoomInfo=true
    }
  }
}
</script>

<style>
.bodyBack{
    background-color:#fff;
    min-height:100vh;
    width:100vw;
    overflow-x:hidden;
}
.boatImgRect{
    padding:0 1.5em;
    position:relative;
    border-radius:1em;
    overflow:hidden;
    margin-bottom:1.5em;
}
.boatImgRect img{
    border-radius:1em;
}
.custom-indicator {
    position: absolute;
    right: 1em;
    bottom: 1em;
    padding: 0.1em 0.7em;
    font-size: 0.7em;
    text-align:center;
    color:#fff;
    background: rgba(29, 29, 29, 0.33);
  }
.boatImgRect .imgTitle{
    color:#fff;
    position:absolute;
    left:0;
    right:0;
    bottom:0;
    line-height:2.6em;
    z-index:1;
    text-align:center;
    font-size:0.9em;
}

.SerchRect{
    padding:0 1.5em;
}
.SerchRect .SearchLine{
    border:1px solid #ccc;
    border-radius:5px;
    margin-bottom:1.5em;
}
.SerchRect .van-cell{
    padding:5px 16px;
}
.tourTitle{
    margin-bottom:1.5em;
    padding:0 1.5em;
    font-weight:700;
    background: linear-gradient(to bottom, #F3E2B0, #DAC083); /* 渐变色的起始和结束颜色 */
    color: transparent; /* 隐藏文字颜色 */
    display: inline-block; /* 使背景应用到文本 */
    -webkit-background-clip: text; /* 使用背景作为文字填充，适用于 Webkit 浏览器 */
    background-clip: text; /* 使用背景作为文字填充 */
}
.tourTitle span{
    font-size:1.1em;
}
.roomRects{
    padding:0 1.5em;
}
.roomRect{

    border-bottom:1px solid #EEEEEE;
    margin-bottom:1em;
    padding-bottom:0.5em;
}
.roomRect:nth-last-child(-n+2) {
    border-bottom: none;
}

.roomRect .roomImg{
    border-radius:0.4em;
    overflow:hidden;
}

.roomRect .roomTitle{
    font-weight:700;
    font-size:0.9em;
    line-height:1.3em;
    text-align:left;
}
.roomRect .tagLine{
    padding:0.3em;
    text-align:left;
}
.roomRect .tagLine span{
    margin-right:0.5em;
}
.roomRect .priceLine{
    padding:0.3em 0;
    text-align:left;
}
.roomRect .priceLine .price{
    font-size:0.8em;
    font-weight:700;
}
.roomRect .priceLine .price span{
    font-size:1.6em;
}
.roomRect .priceLine .free{
    text-align:right;
    font-size:0.8em;
    color:#777777;
}
.roomRect .priceLine .freeEmpty{
    text-align:right;
    font-size:0.8em;
    color:#FF3434;
}

.searchButton{
    margin-bottom:1.5em;
    border-radius:0.6em;
    position:relative;
}
.searchButton i{
    position:absolute;
    right:0.6em;
    top:-12px;
    font-size:0.8em;
}
.boatInfoRect{
    padding:0 1em;
    margin-bottom:1.5em;
}
.infoTitleOpen
{
    color:#1867D6;
    background-color:#F3F8FF;
    border-radius:0.5em;
    padding:0.8em 0.5em;
    font-weight:700;
    letter-spacing: 1px;
    margin:0.5em 0;
    font-size:0.9em;
}

.infoTitleClose
{
  color:#1867D6;
    background-color:#F3F8FF;
    border-radius:0.5em;
    padding:0.8em 0.5em;
    font-weight:700;
    letter-spacing: 1px;
    margin:0.5em 0;
    font-size:0.9em;
}
.infoTitleOpen i{
    float:right;
    font-size:0.8em;
    color:#999999;
    line-height:1.7em;
}
.infoTitleClose i{
    float:right;
    font-size:0.8em;
    color:#999999;
    line-height:1.7em;
}
.infoLineRect{
    border:1px solid #DCDCDC;
    border-radius:0.5em;
    background-color:#fff;
    box-shadow: 2px 2px 5px #ccc;
    min-height:10vw;
    padding:1em;
    font-size:0.8em;
    line-height:1.6em;
}
.infoLineRect .line{
    color:#777777;
    padding:0.3em 0;
}
.infoLineRect .line .rightIcon{
    color:#93C44E;
}

.tourAllTitle{
  color:#000;
  font-size:0.9em;
  padding:0.5em 0;
}
.tourRect{
  border-bottom:1px solid #EEEEEE;
  color:#777777;
}
.tourRect .title{
  color:#000;
  font-weight:700;
  padding:0.8em 0;
}
.tourRect i{
  color:#4790FF;
  margin-right:0.3em;
}
.textRect{
    line-height:1.8em !important;
    color:#777777;
}

.roomPopInfoRect{
    width:calc(100vw - 6em);

    padding:1em;
    border-radius:0.5em;
    background-color:#fff;
    overflow:hidden;
}
.roomPopInfoRect .topTitle{
    font-size:1em;
    color:#333333;
    line-height:2em;
    padding-bottom:0.5em;
    font-weight:700;
}
.roomPopInfoRect .closeIcon{
    text-align:right;
    color:#AAAAAA;
}
.roomPopInfoRect .roomImgRect{
    border-radius:0.3em;
    overflow:hidden;
}
.roomPopInfoRect .roomImgRect img{
    border-radius:0.3em;
    overflow:hidden;
}
.roomPopInfoRect .roomTitle{
    font-weight:700;
    font-size:0.9em;
    padding:0.5em 0;
}
.roomPopInfoRect .tagList{
    color:#777777;
    font-size:0.8em;

}
.roomPopInfoRect .tagList i{
    color:#333333;
    margin-right:0.5em;
    font-size:0.8em;
}
.roomPopInfoRect .tagLine{
    padding:0.2em 0;
}
.roomPopInfoRect .roomAbout{
    padding:0.8em 0;
    color:#777777;
    font-size:0.8em;
    line-height:1.8em;
    max-height:30vh;
    overflow-y:scroll;
}

.topStar{
  text-align: center;
  padding: 1em;
 
}
.scoreLine{
 font-weight: 700;
  margin-top: 0.5em;
}
.avgScore{
  margin-top: 1em;
}
.avgScore .lineScore{
  text-align: right;
  color: #1258AD;
}
.avgScore .barBack{
  background-color: #D6D6D6;
  height: 5px;
  width: 100%;
  margin-top: 0.5em;
  margin-bottom: 1.5em;
}
.avgScore .barBack .barRect{
  background-color: #FFC01E;
  height: 5px;
}

.commentRect{
  margin-top: 2em;
}

.commentRect .commentTop{
  background-color: #F8F9FA;
  height: 6em;
  position: relative;
}
.commentRect .commentTop .leftRect{
  position: absolute;
  left: 1em;
  top: 1em;
}
.commentRect .commentTop .score{
  margin-top: 0.5em;
  font-weight: 700;
  font-size: 1.1em;
}
.commentRect .commentTop .score span{
  font-size: 1.2em;
}
.commentRect .commentTop .icon{
  position: absolute;
  right: 1em;
  top: 1em;
  width: 4em;
  height: 4em;
  overflow: hidden;
  border-radius: 4em;
}
.commentRect .commentTop .icon img{
  width: 100%;
  height: 100%;
}
.commentRect .commentTop .rightRect1{
  position: absolute;
  right: 6em;
  top: 1.5em;
  text-align: right;
}
.commentRect .commentTop .rightRect1 span{
  font-size: 1.15em;
}
.commentRect .commentTop .rightRect2{
  position: absolute;
  right: 6em;
  color: #777777;
  top:3.4em;
  text-align: right;
}
.commentRect .commentbody{
  margin-top: 1em;
  color: #777777;
  line-height: 1.8em;
}
</style>
